import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import {defaultVariabls} from "../../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import Grid from "@material-ui/core/Grid/Grid";
import {connect} from "trim-redux";
import Typography from "@material-ui/core/Typography/Typography";
import {currencySymbol, price} from "../../../../../config/values";
import Divider from "@material-ui/core/Divider/Divider";
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';
import SubTitle from "../../../../components/elements/SubTitle";
import SingleOrderItem from "../../../orders/components/SingleOrderItem";
import {beSupplier, updateRedux} from "../../../../../config/Security";
import GetConfirmationText from "../../../../components/elements/GetConfirmationText";
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import axios from "axios";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';

import Button from "@material-ui/core/Button/Button";

class SingleOrder extends React.Component {

    state = {
        order:this.props.item,
    };
    classes = this.props.classes;
    async handleConfirmOrder(){
        let {order} = this.state;
        let data = new FormData();
        data.append('id', order.id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/change_order_status`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataEdited, {
                    variant: 'success',
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataEditingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    async handlePayOrder(){
        let {order} = this.state;
        let data = new FormData();
        data.append('id', order.id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/pay_order_to_shop`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.purchaseDone, {
                    variant: 'success',
                });
                updateRedux();
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.purchaseRejected, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    render(){
        let {shop} = this.state.order;
        let {order} = this.state;
        let {factor} = this.props;

        return (
            <Grid container spacing={2} alignItems="center">
                {
                    !!shop &&
                    <Grid item xs={12}>
                        <div className="order-items-holder mb-15 mt-15">
                            <Typography>{Translate.shopName} <span className="result">{shop.name}</span></Typography>
                            <Typography>
                                <FiberManualRecordRoundedIcon fontSize="small"/>
                            </Typography>
                            <Typography>{Translate.phone} <span className="result">{shop.phone}</span></Typography>
                            {
                                !!order.sell_agent_id &&
                                    <>
                                        <Typography>
                                            <FiberManualRecordRoundedIcon fontSize="small"/>
                                        </Typography>
                                        <Typography>{Translate.sell_agent} <span className="result"><a className="link" href={`${defaultVariabls.React}/manage/agent/${order.sell_agent.id}`} target="_blank">{order.sell_agent.user.first_name + " " + order.sell_agent.user.last_name}</a></span></Typography>
                                        <Typography>{Translate.sell_commission_amount} <span className="result">{price(order.sell_commission)} {currencySymbol}</span></Typography>
                                    </>
                            }
                            {
                                !!order.buy_agent_id &&
                                <>
                                    <Typography>
                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                    </Typography>
                                    <Typography>{Translate.buy_agent} <span className="result"><a className="link" href={`${defaultVariabls.React}/manage/agent/${order.buy_agent.id}`} target="_blank">{order.buy_agent.user.first_name + " " + order.buy_agent.user.last_name}</a></span></Typography>
                                    <Typography>{Translate.buy_commission_amount} <span className="result">{price(order.buy_commission)} {currencySymbol}</span></Typography>
                                </>
                            }
                        </div>
                    </Grid>
                }
                <Grid item xs={12}>
                    <div className="order-items-holder">
                        <Typography>{Translate.status} <span className="result" style={{color: order.status === "pending" ? "#f82e4e" : ''}}>{Translate[order.status]}</span>
                            {
                                order.status === "payed_to_shop" &&
                                <Button
                                    color="primary"
                                    component={"a"}
                                    href={`${defaultVariabls.website}/view/seller-invoice/${factor.number}/${shop.id}`}
                                    target="_blank"
                                    size="small"
                                    startIcon={<ChevronLeftRoundedIcon/>}
                                >
                                    {Translate.viewSellerInvoice}
                                </Button>
                            }
                        </Typography>
                        {
                            this.props.factor.status !== "rejected" ?
                                <>
                                {
                                    order.status === "pending" &&
                                    <Typography>
                                        <GetConfirmationText
                                            tooltip={Translate.changeStatus}
                                            className={this.classes.link}
                                            style={{
                                                cursor:"pointer",
                                                color: this.props.primary_color,
                                                marginBottom:0,
                                                border: "1px solid rgb(89, 165, 216)",
                                                padding: "5px 8px",
                                                borderRadius: 4
                                            }}
                                            handleAction={() => this.handleConfirmOrder()}
                                            question={Translate.isOrderReceivedToYou}
                                            icon={<CheckBoxIcon/>}
                                            color={this.props.primary_color}
                                        >
                                            {Translate.receivingConfirmation}
                                        </GetConfirmationText>
                                    </Typography>
                                }
                                </> : null
                        }

                        <Typography>
                            <FiberManualRecordRoundedIcon fontSize="small"/>
                        </Typography>
                        <Typography>{Translate.commission} <span className="result">{price(order.commission)} {currencySymbol}</span></Typography>
                        <Typography>
                            <FiberManualRecordRoundedIcon fontSize="small"/>
                        </Typography>
                        <Typography>{Translate.total_price_to_get} <span className="result">{price(order.total_price_payed - order.commission)} {currencySymbol}</span></Typography>
                        {
                            this.props.factor.status !== "rejected" ?
                                <>
                                    {
                                        order.status === "ready" &&
                                        <Typography>
                                            <GetConfirmationText
                                                tooltip={Translate.payToShop}
                                                className={this.classes.link}
                                                style={{
                                                    cursor: "pointer",
                                                    color: this.props.primary_color,
                                                    marginBottom: 0
                                                }}
                                                handleAction={() => this.handlePayOrder()}
                                                question={Translate.payToShopAreYouSure}
                                                icon={<CheckBoxIcon/>}
                                                color={this.props.primary_color}
                                            >
                                                {Translate.payToShop}
                                            </GetConfirmationText>
                                        </Typography>
                                    }
                                </> : null
                        }
                    </div>

                </Grid>
                <Grid item xs={12}>
                    <SubTitle align="left">{Translate.productsList}</SubTitle>
                </Grid>
                <Grid item xs={12}>
                    {
                        order.order_items.map((item,index) => (
                            <SingleOrderItem factor_status={factor.status}  key={index} item={item} no_shop reload={() => this.props.reload()}/>
                        ))
                    }
                </Grid>
            </Grid>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SingleOrder))));